import { useTranslation } from 'react-i18next';
import { Button } from './Button';
export function ButtonCancel(props) {
  const {
    t
  } = useTranslation('common');
  return <Button color="primary" {...props} data-testid="button-cancel">
			{props.children || t('buttons.cancel')}
		</Button>;
}